import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NotificationControllerService } from '@iota/iota-management-portal-v4-client';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, take } from 'rxjs';
import { LoadNotificationsByReceiverId, NotificationActionTypes, SendMail, SendNotification } from '../actions/notification.actions';
import { getLocationHeader } from 'src/app/shared/utils';

@Injectable()
export class NotificationEffects {
    loadNotificationsByReceiverId$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadNotificationsByReceiverId),
            mergeMap(({ userId }) =>
                this.apiService.getAllNotificationsByReceiverId(userId).pipe(
                    take(1),
                    map((notifications) => ({ type: NotificationActionTypes.LoadNotificationsSuccess, notifications })),
                    catchError((error) => of({ type: NotificationActionTypes.LoadNotificationsFailure, error: error }))
                )
            )
        )
    );

    sendNotification$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SendNotification),
            mergeMap(({ notification }) =>
                this.apiService.upsertNotification(notification, 'response').pipe(
                    take(1),
                    map((results) => ({ type: NotificationActionTypes.SendNotificationSuccess, notification: getLocationHeader(results) })),
                    catchError((error) => of({ type: NotificationActionTypes.SendNotificationFailure, error: error }))
                )
            )
        )
    );

    sendMail$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SendMail),
            mergeMap(({ mail }) =>
                this.apiService.sendEmail(mail).pipe(
                    map(() => ({ type: NotificationActionTypes.SendMailSuccess })),
                    catchError((error) => of({ type: NotificationActionTypes.SendMailFailure, error: error }))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private store: Store,
        private apiService: NotificationControllerService
    ) {}
}
